





































































































































































































import Vue, { PropType } from "vue";
import dayjs from "dayjs";
import Overlay from "@/components/Atoms/Overlay/index.vue";
import FloatingView from "@/components/Atoms/FloatingView/index.vue";
import Button from "@/components/Atoms/Button/index.vue";
import ButtonConfig from "@/components/Molecules/ButtonConfig/index.vue";
import Heading from "@/components/Atoms/Typography/Heading/index.vue";
import Caption from "@/components/Atoms/Typography/Caption/index.vue";
import TextArea from "@/components/Atoms/Forms/TextArea/index.vue";
import SelectBox from "@/components/Atoms/Forms/Selectbox/index.vue";
import EventField from "@/components/Pages/Plan/Atoms/eventField/index.vue";
import { RecruitmentEventTypes } from "@/api/types";
import { KEYCODE } from "@/constants/event";

import "@/components/icons";
import { Data, Methods, Computed, Props } from "./types";

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    Overlay,
    FloatingView,
    TextArea,
    SelectBox,
    Button,
    ButtonConfig,
    Heading,
    Caption,
    EventField
  },
  props: {
    messages: {
      type: Array as PropType<Props["messages"]>,
      required: true
    },
    projectPeriodObject: {
      type: Object as PropType<Props["projectPeriodObject"]>,
      required: true
    },
    selectedEvent: {
      type: Object as PropType<Props["selectedEvent"]>,
      default: undefined
    }
  },
  data() {
    return {
      formElement: {
        event_types: RecruitmentEventTypes
      },
      recruitmentEvent: {
        name: "",
        event_type: "event",
        start_at: "",
        end_at: "",
        description: "",
        reference_url: ""
      },
      initialRecruitmentEvent: [],
      selectDate: {
        start_at: {
          year: String(this.projectPeriodObject.planStartDate.year()),
          month: String(this.projectPeriodObject.planStartDate.month() + 1),
          day: String(this.projectPeriodObject.planStartDate.date())
        },
        end_at: {
          year: String(this.projectPeriodObject.planStartDate.year()),
          month: String(this.projectPeriodObject.planEndDate.month() + 1),
          day: String(this.projectPeriodObject.planEndDate.date())
        }
      }
    };
  },
  computed: {
    isDeleteVisible() {
      return Boolean(this.selectedEvent);
    },
    submitLabel() {
      return this.selectedEvent ? "保存" : "追加";
    }
  },
  mounted() {
    this.setDefaultSelectedDates();
    this.initialRecruitmentEvent = Object.assign({}, this.recruitmentEvent);

    const $eventName = (this.$refs.eventName as Vue).$el as HTMLElement;
    $eventName.focus();
    window.addEventListener("keyup", this.handlePressEsc);
  },
  methods: {
    checkDateWithinRange(date) {
      const planStartDate = this.getPlanStartDate();
      const planEndDate = this.getPlanEndDate();
      if (
        (date.isSame(planStartDate) || date.isAfter(planStartDate)) &&
        (date.isSame(planEndDate) || date.isBefore(planEndDate))
      ) {
        return true;
      }
      return false;
    },
    checkDateUnderRange(date) {
      const planStartDate = this.getPlanStartDate();
      if (date.isBefore(planStartDate)) {
        return true;
      }
      return false;
    },
    setSelectedDate(type, date) {
      this.selectDate[type].year = String(date.year());
      this.selectDate[type].month = String(date.month() + 1);
      this.selectDate[type].day = String(date.date());
    },
    setDefaultSelectedDates() {
      if (!this.selectedEvent) {
        const today = dayjs();
        //開始日を挿入
        if (this.checkDateWithinRange(today)) {
          this.setSelectedDate("start_at", today);
        } else if (this.checkDateUnderRange(today)) {
          if (this.getPlanStartDate().month() <= today.month()) {
            const altYearDate = today.year(this.getPlanStartDate().year()); //今日の日付の年を計画開始年に置換した日付
            this.setSelectedDate("start_at", altYearDate);
          }
        }
        this.modifyDate("start_at");

        //終了日を挿入
        const endDate = dayjs(this.recruitmentEvent.start_at).add(6, "days"); //開始日から7日後（初日を含む）の日付
        if (endDate.isAfter(this.getPlanEndDate())) {
          this.setSelectedDate("end_at", this.getPlanEndDate());
        } else {
          this.setSelectedDate("end_at", endDate);
        }
      } else {
        this.recruitmentEvent = Object.assign({}, this.selectedEvent);
        this.setSelectedDate("start_at", this.selectedEvent.startDate);
        this.setSelectedDate("end_at", this.selectedEvent.endDate);
      }
      this.modifyDate("start_at");
      this.modifyDate("end_at");
    },
    getPlanStartDate() {
      return this.projectPeriodObject.planStartDate.startOf("day");
    },
    getPlanEndDate() {
      return this.projectPeriodObject.planEndDate.endOf("day");
    },
    getYears() {
      return [
        {
          value: `${this.getPlanStartDate().year()}`,
          label: `${this.getPlanStartDate().year()}`
        },
        {
          value: `${this.getPlanEndDate().year()}`,
          label: `${this.getPlanEndDate().year()}`
        }
      ];
    },
    getMonths(type) {
      const start: number = this.getPlanStartDate().month() + 1;
      const end: number = this.getPlanEndDate().month() + 1;
      let targetDate = this.selectDate[type];
      let months = [];

      switch (String(targetDate.year)) {
        case String(this.getPlanStartDate().year()): {
          months = [...Array(12 - start + 1).keys()].map(e => ({
            value: `${e + start}`,
            label: `${e + start}`
          }));

          const hasCurrentMonth = months.some(month => {
            return month.value === targetDate.month;
          });
          if (!hasCurrentMonth) {
            targetDate.month = months[0].value;
          }
          return months;
        }

        case String(this.getPlanEndDate().year()): {
          months = [...Array(end - 1 + 1).keys()].map(e => ({
            value: `${e + 1}`,
            label: `${e + 1}`
          }));

          const hasCurrentMonth = months.some(month => {
            return month.value === targetDate.month;
          });
          if (!hasCurrentMonth) {
            targetDate.month = months[0].value;
          }
          return months;
        }
        default:
          months = [...Array(12 - 1 + 1).keys()].map(e => ({
            value: `${e + 1}`,
            label: `${e + 1}`
          }));
          return months;
      }
    },
    getDates(year, month) {
      const maxDate = this.getFinalDate(year, month);
      return [...Array(maxDate).keys()].map(e => ({
        value: `${e + 1}`,
        label: `${e + 1}`
      }));
    },
    getFinalDate(year, month) {
      return dayjs(new Date(Number(year), Number(month) - 1))
        .endOf("month")
        .date();
    },
    formatDate(year, month, day) {
      let date: string = "";
      if (year || month || day) {
        date = dayjs(
          new Date(Number(year), Number(month) - 1, Number(day))
        ).format("YYYY-MM-DD");
      }
      return date;
    },
    validateDate(type) {
      this.modifyDate(type);
      if (!dayjs(this.recruitmentEvent[type]).isValid()) {
        this.selectDate[type].day = String(
          this.getFinalDate(
            this.selectDate[type].year,
            this.selectDate[type].month
          )
        );
      }
    },
    modifyDate(type) {
      this.recruitmentEvent[type] = this.formatDate(
        this.selectDate[type].year,
        this.selectDate[type].month,
        this.selectDate[type].day
      );
    },
    handleClickEventViewClose() {
      this.$emit("clickEventViewClose");
    },
    trimName() {
      if (this.recruitmentEvent.name === "") {
        return;
      }
      this.recruitmentEvent.name = this.recruitmentEvent.name.trim();
    },
    handleClickSubmit() {
      this.modifyDate("start_at");
      this.modifyDate("end_at");
      this.trimName();
      this.$emit("clickSubmit", this.recruitmentEvent);
    },
    handleClickDeleteEventViewOpen() {
      this.$emit("clickDeleteEventViewOpen");
    },
    handlePressEsc(event) {
      if (event.keyCode !== KEYCODE.ESC) {
        return;
      }
      this.$emit("pressEsc", this.eventDataChanged());
    },
    handleEnterSubmit(event) {
      if (
        event.keyCode !== KEYCODE.ENTER &&
        this.recruitmentEvent.name !== ""
      ) {
        return;
      }
      // this.handleClickSubmit();
    },
    eventDataChanged() {
      return (
        JSON.stringify(this.initialRecruitmentEvent) !==
        JSON.stringify(this.recruitmentEvent)
      );
    }
  }
});
